module.exports = __webpack_public_path__ + "img/Mortgage.7d86990b.svg";